// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__bGUq9","clickable":"Pill_clickable__IjVVD","clickHint":"Pill_clickHint__ldvQF","content":"Pill_content__4HE4G"};